<!--系统管理-操作日志列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >

      <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline" >

          <a-form-item
            label="内容" class="ant-form-item2"
          >
            <a-input
              placeholder="请输入" v-model="paramas.keyword"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handlePageList" html-type="button" >
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      列表表格-->
      <div>
        <a-table :columns="columns" :data-source="data" :pagination="pagination" @change="handleTableChange">
        </a-table>
      </div>
    </a-card>


  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'

  const columns = [
    {
      title: '编号',
      dataIndex: 'ID',
      key: 'ID',
    },
    {
      title: '操作',
      dataIndex: 'cOpt',
      key: 'cOpt',
    },
    {
      title: '操作人',
      dataIndex: 'cUserName',
      key: 'cUserName',
    },
    {
      title: '操作时间',
      dataIndex: 'dOptDate',
      key: 'dOptDate',
    },


  ];

  const data = [
    {
      key: '1',
      num:"00123",
      person:"林一",
      time:'2020.06.18',
      type:'修改权限',
    },
    {
      key: '2',
      num:"00123",
      person:"林一",
      time:'2020.06.18',
      type:'修改权限',
    },
    {
      key: '3',
      num:"00123",
      person:"林一",
      time:'2020.06.18',
      type:'修改权限',
    },

    {
      key: '4',
      num:"00123",
      person:"林一",
      time:'2020.06.18',
      type:'修改权限',
    },

    {
      key: '5',
      num:"00123",
      person:"林一",
      time:'2020.06.18',
      type:'修改权限',
    },
  ];

  export default {
    name: 'logList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1:"系统管理",
        titleMsg2:'操作日志',
        titleMsg3:'操作日志',
        data:[],
        columns,
        paramas:{
          keyword:"",
          sceneId:"",
          page:1,
          limit:10,
          cEntID:''
        },

        pagination: {
          current:1,
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
      }
    },
    mounted () {
      let that=this;

      that.paramas.sceneId=that.$store.getters.SCene.ID;
      that.paramas.cEntID=that.$store.getters.User.enterprise.ID;

      that.$bus.$on('scenechange',(target)=> {
        that.paramas.sceneId=target.id;

        that.handlePageList();

      });

      that.handlePageList();
    },

    methods:{
      async handlePageList(){
        let that=this;

        let res= await that.$http.post('OptLog/PageList',that.paramas)

        if(res.data.code=="200"){

          that.data= res.data.obj.list;
          that.pagination.total=res.data.obj.listTotal
        }
        else{
          that.$message.error(res.message)

        }
      },

      handleTableChange(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.paramas.page = pagination.current;
        this.paramas.limit = pagination.pageSize;
        this.handlePageList();
      },
    }
  }
</script>
